import { Link } from "react-router-dom";

const inert = (e) => e.preventDefault();

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const FOOTER_COLUMNS = [
  {
    title: "Programs",
    links: [
      { label: "All Programs", to: "/programs" },
      { label: "Digital Money and Stablecoins", to: "/programs/digital-money-and-stablecoins" },
      { label: "Digital Asset Accounting", to: "/programs/digital-asset-accounting" },
      { label: "Business Payments and Treasury", to: "/programs/business-payments-and-treasury" },
      { label: "Compliance for Digital Finance Operations", to: "/programs/compliance-for-digital-finance-operations" },
      { label: "Digital Asset Audit and Assurance", to: "/programs/digital-asset-audit-and-assurance" },
      { label: "Certification Pathways", to: "/certification-pathways" },
    ],
  },
  {
    title: "Institute",
    links: [
      { label: "Resources", to: "/resources" },
      { label: "Membership", to: "/membership" },
      { label: "Partners", to: "/partners" },
      { label: "About", to: "/about" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Use", to: "/terms-of-use" },
      { label: "Cookie Policy", to: "/cookie-policy" },
    ],
  },
];

const linkClasses =
  "text-sm text-primary-foreground/85 underline-offset-4 transition-colors hover:text-primary-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-sm";

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="footer">
      <div className="mx-auto w-full max-w-[1288px] px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="max-w-xs">
            <Link
              to="/"
              className="inline-flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-md"
              data-testid="footer-logo-link"
            >
              <img
                src="/wfii-logo-white.png"
                alt="World Financial Innovation Institute"
                className="h-12 w-auto"
                data-testid="footer-logo-image"
              />
            </Link>
            <a
              href="mailto:info@wfi-institute.com"
              className="mt-4 block w-fit text-sm text-primary-foreground/70 transition-colors hover:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-md"
              data-testid="footer-email-link"
            >
              info@wfi-institute.com
            </a>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h3 className="text-xs font-medium uppercase tracking-wide text-primary-foreground/60">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        className={linkClasses}
                        data-testid={`footer-link-${slug(link.label)}`}
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href="#"
                        onClick={inert}
                        className={linkClasses}
                        data-testid={`footer-link-${slug(link.label)}`}
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-primary-foreground/15 pt-6">
          <p className="text-center text-xs text-primary-foreground/60">
            © {new Date().getFullYear()} World Financial Innovation Institute. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
